import { render, staticRenderFns } from "./AssinaturaPrincipalInfo.vue?vue&type=template&id=518c2846"
import script from "./AssinaturaPrincipalInfo.vue?vue&type=script&lang=js"
export * from "./AssinaturaPrincipalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports